import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Within the `}<inlineCode parentName="p">{`docs/`}</inlineCode>{` directory, there are a number of important directories and files to be aware of. You probably already know about the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` and `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file. If not, read the `}<Link to="/documentation/set-up" mdxType="Link">{`Getting Started`}</Link>{` section.`}</p>
    <h2>{`Content`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`content`}</inlineCode>{` directory holds our content. An important note is that the folders you use should match your desired URLS. For example, if I was writing a `}<strong parentName="p">{`character profile`}</strong>{` for `}<strong parentName="p">{`Luke Skywalker`}</strong>{`, I might want the URL to be `}<inlineCode parentName="p">{`/characters/luke_skywalker`}</inlineCode>{`. So my folder structure should match this, therefore my file path should be `}<inlineCode parentName="p">{`docs/content/characters/luke_skywalker.mdx`}</inlineCode>{`.`}</p>
    <h2>{`Sidebar Navigation`}</h2>
    <p>{`The Sidebar navigation is generated from the content in `}<inlineCode parentName="p">{`src/@primer/gatsby-theme-doctocat/nav.yml`}</inlineCode>{`. Each entry in `}<inlineCode parentName="p">{`nav.yml`}</inlineCode>{` should have a `}<inlineCode parentName="p">{`title`}</inlineCode>{`, `}<inlineCode parentName="p">{`url`}</inlineCode>{`, and an optional `}<inlineCode parentName="p">{`children`}</inlineCode>{` list to create nested navigation links.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`# src/@primer/gatsby-theme-doctocat/nav.yml
- title: Example
  url: /example
  children:
    - title: Nested Example
      url: /nested/example
`}</code></pre>
    <p>{`There are some caveats though:`}</p>
    <ul>
      <li parentName="ul">{`Doctocat (the theme) only supports `}<strong parentName="li">{`one`}</strong>{` level of nesting.`}</li>
      <li parentName="ul">{`Links are `}<strong parentName="li">{`not`}</strong>{` alphabetized; but rendered in the order they are specified.`}</li>
      <li parentName="ul">{`Items without urls default to the index page.`}</li>
    </ul>
    <h2>{`First Party Components`}</h2>
    <p>{`Between `}<inlineCode parentName="p">{`@primer/components`}</inlineCode>{` and `}<inlineCode parentName="p">{`@primer/gatsby-theme-doctocat`}</inlineCode>{`, there are a lot of useful components, however it can be useful to create additional components to consolidate multiple components into one, or to add additional functionality.`}</p>
    <p>{`These are stored in `}<inlineCode parentName="p">{`docs/src/components/`}</inlineCode>{` and enumerated for export in `}<inlineCode parentName="p">{`docs/src/components/index.js`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      